import React from 'react';
import UpQuote from '../../../shared/icons/UpQuote';

const UpQuoteMarkAtom = () => (
  <UpQuote />
);

export default UpQuoteMarkAtom;
